<template>
  <div class="jingdong-order-list">
    <el-card class="page-card">
      <template #header>
        <div class="card-header">京东订单列表</div>
      </template>

      <div class="card-body">
        <el-row type="flex" justify="space-between" align="middle" class="toolbar">
          <el-col>
            <el-button type="primary" icon="el-icon-refresh" @click="fetchOrderList">刷新</el-button>
          </el-col>
          <el-col>
            <el-input size="small" placeholder="按订单号搜索" v-model="searchParams.orderId" style="width:200px" clearable
              @clear="fetchOrderList" @keyup.enter.native="fetchOrderList">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchOrderList"></i>
            </el-input>
            <el-date-picker size="small" v-model="searchParams.orderTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-left:8px"></el-date-picker>
          </el-col>
        </el-row>

        <el-table :data="orderList" stripe border style="width: 100%; margin-top: 12px" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" header-align="center" width="80"></el-table-column>
          <el-table-column prop="order_no" label="订单号" align="center" header-align="center"></el-table-column>
          <el-table-column prop="receiver_name" label="收货人" align="center" header-align="center"></el-table-column>
          <el-table-column prop="receiver_mobile" label="联系电话" width="120" align="center"
            header-align="center"></el-table-column>
          <el-table-column prop="receiver_address" label="收货地址" align="center" header-align="center"></el-table-column>
          <el-table-column prop="created_at" label="下单时间" width="180" align="center"
            header-align="center"></el-table-column>
          <el-table-column prop="paid_amount" label="订单金额" width="120" align="center" header-align="center">
            <template slot-scope="scope">
              <span class="amount">¥ {{ scope.row.paid_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_status" label="订单状态" width="120" align="center" header-align="center">
            <template slot-scope="scope">
              <el-tag size="small" :type="getStatusTagType(scope.row.order_status)">{{
                formatStatus(scope.row.order_status) }}</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="paymentMethod" label="支付方式" width="120" align="center"
            header-align="center"></el-table-column> -->
          <!-- <el-table-column label="操作" width="120" fixed="right" align="center" header-align="center">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="viewOrderDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 15, 20, 50]"
            :page-size="pageSize" :current-page="currentPage" @size-change="handleSizeChange"
            @current-change="handlePageChange"></el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 订单详情对话框 -->
    <el-dialog :visible.sync="detailDialog" title="订单详情" width="600px" :close-on-click-modal="false">
      <div v-if="detailData">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="订单号">{{ detailData.order_no }}</el-descriptions-item>
          <el-descriptions-item label="收货人">{{ detailData.receiver_name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailData.receiver_mobile }}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{ detailData.receiver_address }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ detailData.created_at }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">¥ {{ detailData.paid_amount }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{ formatStatus(detailData.order_status) }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">{{ detailData.paymentMethod || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 导入京东订单列表接口
import { jingdongOrderList } from '@/api/api'

export default {
  name: 'JingdongOrderList',
  data() {
    return {
      // 订单列表数据
      orderList: [],
      // 搜索参数
      searchParams: {
        orderId: '',
        orderTime: [],
        // 可以添加更多搜索条件
      },
      // 分页信息
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 加载状态
      loading: false,
      // 订单详情对话框
      detailDialog: false,
      detailData: null
    }
  },
  created() {
    // 页面加载时获取订单列表
    this.fetchOrderList()
  },
  methods: {
    // 获取京东订单列表
    fetchOrderList() {
      this.loading = true
      // 构建请求参数
      const params = {
        ...this.searchParams,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        start_date: this.searchParams.orderTime[0] || '',
        end_date: this.searchParams.orderTime[1] || ''
      }

      // 调用京东订单列表接口
      jingdongOrderList(params)
        .then(response => {
          // 根据后端返回的数据格式处理
          if (response && response.code === 200) {
            this.orderList = response.data.data || []
            this.total = response.data.total || 0
            this.currentPage = response.data.pageNum || 1
            this.pageSize = response.data.per_page || 10
          } else {
            this.$message.error('获取订单列表失败')
            this.orderList = []
            this.total = 0
          }
        })
        .catch(error => {
          console.error('获取京东订单列表失败:', error)
          this.$message.error('获取订单列表异常，请重试')
          this.orderList = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 重置搜索条件
    resetSearch() {
      this.searchParams = {
        orderId: '',
        orderTime: []
      }
      this.currentPage = 1
      // 重置后重新查询
      this.fetchOrderList()
    },

    // 分页变化处理
    handlePageChange(page) {
      this.currentPage = page
      this.fetchOrderList()
    },

    // 每页条数变化处理
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchOrderList()
    },

    // 查看订单详情
    viewOrderDetail(order) {
      this.detailData = order
      this.detailDialog = true
    },
    // 格式化订单状态
    formatStatus(order_status) {
      const statusMap = {
        1: '已发货',
        2: '已完成',
        3: '已退款',
        4: '已取消'
      }
      return statusMap[order_status] || '未知'
    },
    // 获取状态标签类型
    getStatusTagType(order_status) {
      const typeMap = {
        1: 'info',
        2: 'success',
        3: 'warning',
        4: 'danger'
      }
      return typeMap[order_status] || 'default'
    }
  }
}
</script>

<style scoped>
.jingdong-order-list {
  padding: 20px;
}

.page-card {
  height: calc(100vh - 64px - 48px);
  overflow-y: auto;
}

.card-header {
  font-weight: 700;
  color: #409EFF;
}

.card-body {
  padding: 12px;
}

.toolbar {
  margin-bottom: 6px;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.amount {
  color: #F56C6C;
  font-weight: 700;
}
</style>